import { z } from "zod";
/**
 * The units a person can read and type loads in (`D266`).
 *
 * A DISPLAY preference and nothing else. Every load on the wire — a set, a
 * target, a record, a body-weight measurement, a goal — is kilograms, in both
 * directions, whatever this says; the app converts at the edge and the
 * trainer is told which unit to speak in. A new field named `…Lb` anywhere in
 * this contract is the bug this sentence exists to prevent.
 *
 * At the contract ROOT, beside `locale.ts`, for the reason that file gives:
 * the unit a person reads is not an identity concept, though its one writer
 * today is an `iam` route. `Account` restates the pair (`AccountWeightUnit`)
 * because `core/model/` may not import this package.
 */
export const WEIGHT_UNITS = ["kg", "lb"];
export const weightUnit = z.enum(WEIGHT_UNITS);
//# sourceMappingURL=weight-unit.js.map